import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';

const mapDispatch = (dispatch) => {
    return {
        pasoSiguiente: () => {
            dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
        }
    }
}

class Correo extends React.Component {
    
    cerrar = () => {
		this.props.pasoSiguiente();
		goTo("login");
		//window.location.href = '/#!/';
	}
	
    render() {
        return <div className='text-content no-margin'>
            <div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <h3>Transacción exitosa</h3>
                    <br />
                </div>
            </div>
            <div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <img src={require("../img/vector_ok.png")} />
                    <br />
                </div>
            </div>
            <div className="row">
                <div className="col" style={{"textAlign": "center"}}>
                    <p>Tu solicitud de registro ha sido <br/> exitosa, recibirás un correo <br/> electrónico para acceder a tu <br/> información.</p>
                </div>
            </div>
            <div className="row">
                <div style={{"textAlign": "center"}}>
                    <button className='orange-circle' onClick={this.cerrar.bind(this)}>
					    <i></i>
					</button>
                </div>
            </div>
			
		</div>;
    }
}

export default connect(null, mapDispatch)(Correo);


// WEBPACK FOOTER //
// ./src/gnp-registro/correo.cmpt.js